import { CarePlanScreen } from "app/screens/residents/show/CarePlanScreen";

export default function ResidentCarePlansPage() {
  return <CarePlanScreen />;
}
